import { render, staticRenderFns } from "./BlackAndWhite.vue?vue&type=template&id=9da4c476&"
import script from "./BlackAndWhite.vue?vue&type=script&lang=js&"
export * from "./BlackAndWhite.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/BlackAndWhte.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports